module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-left-bottom-ties.ba569972.png";